import { useUserRole } from "@/hooks/useUserRole";
import { ControllerDashboardView } from "@/components/controller/dashboards/ControllerDashboardView";
import { PMDashboardView } from "@/components/controller/dashboards/PMDashboardView";
import { FieldDashboardView } from "@/components/controller/dashboards/FieldDashboardView";
import { AccountingDashboardView } from "@/components/controller/dashboards/AccountingDashboardView";

const ControllerDashboard = () => {
  const { data: roleInfo, isLoading } = useUserRole();

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  switch (roleInfo?.roleName) {
    case "project_manager":
      return <PMDashboardView />;
    case "field_supervisor":
      return <FieldDashboardView />;
    case "accounting":
      return <AccountingDashboardView />;
    case "controller":
    case "admin":
    default:
      return <ControllerDashboardView />;
  }
};

export default ControllerDashboard;
